import React from 'react';
import './styles.css';





export const DarwinTituloEncabezado = () => {


  return (
    <>


        <div className='DarwinTituloEncabezado-Principal-Container'>

                <div className='DarwinTituloEncabezado-subContainer'>

                        <div className='DarwinTituloEncabezado-titulo'/>

                        <div className='DarwinTituloEncabezado-imagen'/>
                        
                </div>
        </div>

        
    </>
  )
}
